<div class="print-main-container">
  <div>
    <p class="swot-names">STRENGTHS</p>
    @for (str of swotana.strengths; track str) {
      <div>
        <p  [innerHTML]="str.strength" ></p>
        <table class="table table-responsive border" >
          <thead>
            <tr class="bordered-tm chan-2 ">
              <th class="header-color">OUR RESPONSE</th>
              <th class="header-color">TECHNOLOGY THEMES</th>
              <th class="header-color">PROJECTS</th>
              <th class="header-color">STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bordered-tm chan-3 ">
              <td style="width:21%">
                <span [innerHTML]="str.response" ></span>
              </td>
              <td >
                <div class="">
                  <div class=" d-flex  text-dark tags-overflow">
                    @for (stre of str.obj; track stre) {
                      <span class="m-2" [innerHTML]="stre.name" ></span>
                    }
                  </div>
                </div>
              </td>
              <td >
                <div class=" ">
                  <div class=" d-flex text-dark tags-overflow ">
                    @for (proj of str.projects; track proj) {
                      <span class="m-1" [innerHTML]="proj.prgName" ></span>
                    }
                  </div>
                </div>
              </td>
              <td style="width:20%">
                <p  [innerHTML]="str.strengths" ></p></td>
              </tr>
            </tbody>
          </table>
        </div>
      }
    </div>

    <div>
      <p class="swot-names">OPPORTUNITIES</p>
      @for (opp of swotana.oppurtunities; track opp) {
        <div>
          <p  [innerHTML]="opp.oppurtunity" ></p>
          <table class="table table-responsive border" >
            <thead>
              <tr class="bordered-tm chan-2 ">
                <th class="header-color">OUR RESPONSE</th>
                <th class="header-color">TECHNOLOGY THEMES</th>
                <th class="header-color">PROJECTS</th>
                <th class="header-color">STATUS</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bordered-tm chan-3 ">
                <td style="width:20%">
                  <span [innerHTML]="opp.response" ></span>
                </td>
                <td>
                  <div class="">
                    <div class=" d-flex  text-dark tags-overflow">
                      @for (oppe of opp.obj; track oppe) {
                        <span [innerHTML]="oppe.name" ></span>
                      }
                    </div>
                  </div>
                </td>
                <td>
                  <div class="">
                    <div class=" d-flex  text-dark tags-overflow">
                      @for (proj of opp.projects; track proj) {
                        <span class="m-1" [innerHTML]="proj.prgName" ></span>
                      }
                    </div>
                  </div>
                </td>
                <td style="width:20%">
                  <p  [innerHTML]="opp.oppurtunitys" ></p></td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      </div>

      <div>
        <p class="swot-names">WEAKNESSES</p>
        @for (weak of swotana.weaknesses; track weak) {
          <div>
            <p  [innerHTML]="weak.weakness" ></p>
            <table class="table table-responsive border" >
              <thead>
                <tr class="bordered-tm chan-2 ">
                  <th class="header-color">OUR RESPONSE</th>
                  <th class="header-color">TECHNOLOGY THEMES</th>
                  <th class="header-color">PROJECTS</th>
                  <th class="header-color">STATUS</th>
                </tr>
              </thead>
              <tbody>
                <tr class="bordered-tm chan-3 ">
                  <td style="width:20%">
                    <span [innerHTML]="weak.response" ></span>
                  </td>
                  <td>
                    <div class=" ">
                      <div class=" d-flex text-dark tags-overflow">
                        @for (wee of weak.obj; track wee) {
                          <span [innerHTML]="wee.name" ></span>
                        }
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class=" ">
                      <div class=" d-flex text-dark tags-overflow">
                        @for (proj of weak.projects; track proj) {
                          <span class="m-1" [innerHTML]="proj.prgName" ></span>
                        }
                      </div>
                    </div>
                  </td>
                  <td style="width:20%">
                    <p  [innerHTML]="weak.weaknesss" ></p></td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </div>

        <div>
          <p class="swot-names">THREATS</p>
          @for (threat of swotana.threats; track threat) {
            <div>
              <p  [innerHTML]="threat.threat" ></p>
              <table class="table table-responsive border" >
                <thead>
                  <tr class="bordered-tm chan-2 ">
                    <th class="header-color">OUR RESPONSE</th>
                    <th class="header-color">TECHNOLOGY THEMES</th>
                    <th class="header-color">PROJECTS</th>
                    <th class="header-color">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="bordered-tm chan-3 ">
                    <td style="width:21%">
                      <span [innerHTML]="threat.response" ></span>
                    </td>
                    <td style="width:21%">
                      <div class=" ">
                        <div class=" d-flex text-dark tags-overflow">
                          @for (thr of threat.obj; track thr) {
                            <span [innerHTML]="thr.name" ></span>
                          }
                        </div>
                      </div>
                    </td>
                    <td style="width:21%">
                      <div class="">
                        <div class=" d-flex text-dark tags-overflow">
                          @for (proj of threat.projects; track proj) {
                            <span class="m-1" [innerHTML]="proj.prgName" ></span>
                          }
                        </div>
                      </div>
                    </td>
                    <td style="width:20%">
                      <p  [innerHTML]="threat.threatss" ></p> </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
